// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"95":"037d13a8","417":"976b9857","421":"356f25ae","453":"92da2d7d","653":"6a96ed88","663":"0bf91206","740":"9d53f64c"}[chunkId] + ".chunk.js";
};